import React, { createContext, JSX, useContext, useMemo, useState } from 'react';

interface LoadingContextType {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

interface LoadingProviderProps {
  children: React.ReactNode;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const LoadingProvider = ({ children }: LoadingProviderProps): JSX.Element => {
  const [isLoading, setIsLoading] = useState(false);

  const objectValues = useMemo(() => {
    return {
      isLoading,
      setIsLoading
    }
  }, [isLoading, setIsLoading]);

  return (
    <LoadingContext.Provider value={objectValues}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = (): LoadingContextType => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};
